module.exports = {
      id: "tv-usage",
      viewBox: "0 0 24.014 24",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#tv",
      toString: function () {
        return this.url;
      }
    }